import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
// import { useI18n } from 'vue-i18n'
import zuqiu from "@/assets/images/zuqiu.png"
import EventBus from "@/uitls/EventBus";

// const { t } = useI18n()

interface tabProps {
  data: any;
}

// const props = defineProps<tabProps>();


export default /*#__PURE__*/_defineComponent({
  name: 'Popups',
  emits: ["chang"],
  setup(__props, { expose, emit }) {
  expose();


const show = ref(false);
const msgdata = ref({}) as any;



const active = ref(0);

EventBus.on("msgbox", ({ type, data }) => {
  console.log('datamsg', data);
  if (type == 1) {
    msgdata.value = data;
  }
  show.value = true;
  setTimeout(() => {
    show.value = false;
  }, 5000)
});

onMounted(() => {
  // show.value = true;
  // setTimeout(()=>{
  //   show.value = false;
  // },7000)
})


const __returned__ = { show, msgdata, emit, active, zuqiu }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})